
import * as gs from "@ivanlog/gs";
import { FormGS, WrapperGS } from "@ivanlog/gs";
import { AppShareX } from "./classes/AppShareX";
import { InjectComponents } from "./plusx-lib/com/tmplsInj";
import { App } from "./plusx-lib/App";
import { AppControllerBase } from "./plusx-lib/controllers/AppControllerBase";
import { GUIControllerBase } from "./plusx-lib/controllers/GUIControllerBase";
import { ChainControllerBase } from "./plusx-lib/controllers/ChainControllerBase";


FormGS.TagClassName='px-form';
WrapperGS.ExtendComponentsByTagClass(FormGS);
InjectComponents();
AppControllerBase;
GUIControllerBase;
ChainControllerBase
new App("");

globalThis.app = new AppShareX();
globalThis.app.startAsync();